module.exports = __webpack_public_path__ + "img/2025big15.e1260740.jpg";